// Module
var code = "<div id=\"V-BEF1FECA-5075-417C-AB3C-D3B3B0FFCEA8\"> <div data-b-component=\"expander\"> <div class=\"expander-header\"> <div data-b-component=\"content\" data-b-comp-content=\"{Binding header}\"></div> </div> <div class=\"expander-body\"> <div data-b-component=\"content\" data-b-comp-content=\"{Binding body}\"></div> </div> </div> </div> ";
// Exports
export default code;